<!--
  Generated template for the ProfilePage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" (click)="navCtrl.back()"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'PROFILE_PAGE_TITLE' | translate }}</ion-title>
    <ion-buttons slot="end" *ngIf="!readOnly">
      <ion-button  (click)="save()">
        {{ 'GLOBAL_SAVE' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="position-relative">
    <!-- *ngIf="activeTop==='cover'" -->
    <swiper-container #coverSlides slidesPerView="1" spaceBetween="5" centeredSlides="true"
      initialSlide="{{ getInitialSlide }}">
      <swiper-slide *ngFor="let bg of backgrounds" (click)="selectBg(bg)">
        <image-container height="150px" src="assets/imgs/profileBackgrounds/{{ bg.img }}"> </image-container>
        <!-- <p>{{ bg.lang | translate}}</p> -->
      </swiper-slide>
    </swiper-container>
    <div class="cover-selected-layer" *ngIf="activeTop === 'preview'" (click)="chooseCover()">
      <image-container height="150px" src="assets/imgs/profileBackgrounds/{{ getCover(profile.themeName) }}">
      </image-container>
      <div class="cover-image-upload vertical-center-outer">
        <div class="vertical-center-inner">
          <ion-icon color="white" name="camera"></ion-icon>
        </div>
      </div>
    </div>
    <!-- <div class="cover-chooser-hint"> -->
      <!-- <span text-small text-center> -->
        <!-- {{ 'PRIVATEPROFILE_TAP_TO_SELECT' | translate }} -->
      <!-- </span> -->
    <!-- </div> -->
  </div>

  <ion-card  overflow-all class="ion-no-margin" style="position: relative; z-index: 100;">
    <ion-item lines="none" class="ion-no-padding">
      <ion-grid>
        <ion-row>
          <ion-col size="auto" class="no-padding">
            <div
              class="profile-image-upload user-image-xl offset-top circle"
              [ngStyle]="{ 'background-image': 'url(' + profile.profilePicLink + ')' }"
              (click)="uploadPhoto()"
            >
              <div class="vertical-center-outer">
                <div class="vertical-center-inner">
                  <ion-icon name="camera" color="light"></ion-icon>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>
  </ion-card>

  <!-- <div *ngIf="activeTop==='photo'">

    <ion-card no-margin overflow-all>
      <ion-grid>
        <ion-row>
          <ion-col col-4 col-md-3 col-xl-2 *ngFor="let picture of photos;index as i">
            <div (tap)="picTap(picture)" (press)="picPress(picture)" class=" image-container" [style.background-image]="'url(' + picture.imageLink + ')'"></div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <button #uploadButton ion-button full>+</button>
    </ion-card>
  </div> -->

  <ion-list class="ion-no-padding">
    <ion-list-header *ngIf="!appDetector.isLeaderBoardApp()" slot="start">
      {{ 'PRIVATEPROFILE_NAME_TITLE' | translate }}
    </ion-list-header>

    <ion-item *ngIf="!appDetector.isLeaderBoardApp()">
      <ion-label position="stacked" class="required alignment-large font-small">
        {{ 'PRIVATEPROFILE_TITLE' | translate }}
      </ion-label>
      <ion-select [(ngModel)]="profile.anrede" cancelText="{{ 'GLOBAL_CANCEL' | translate }}" okText="{{ 'GLOBAL_OK' | translate }}">
        <ion-select-option *ngFor="let title of titles" [value]="title.value">
          {{ title.value }}
        </ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item *ngIf="!appDetector.isLeaderBoardApp()">
      <ion-label position="stacked" class="required alignment-large font-small">
        {{ 'PRIVATEPROFILE_FIRST_NAME' | translate }}
      </ion-label>
      <ion-input [(ngModel)]="profile.forName" type="text"></ion-input>
    </ion-item>

    <ion-item *ngIf="!appDetector.isLeaderBoardApp()">
      <ion-label position="stacked" class="required alignment-large font-small">
        {{ 'PRIVATEPROFILE_LAST_NAME' | translate }}
      </ion-label>
      <ion-input [(ngModel)]="profile.surName" type="text"></ion-input>
    </ion-item>

    <ion-item *ngIf="appDetector.isLeaderBoardApp()">
      <ion-label position="stacked">
        {{ 'PRIVATEPROFILE_ORGANIZER_NAME' | translate }}
      </ion-label>
      <ion-input [(ngModel)]="profile.surName" type="text"></ion-input>
    </ion-item>

    <ion-item *ngIf="!appDetector.isLeaderBoardApp()">
      <ion-label position="stacked" class="alignment-large">
        {{ 'PRIVATEPROFILE_CLUB_NAME' | translate }}
      </ion-label>
      <ion-input [(ngModel)]="profile.clubName" type="text"></ion-input>
    </ion-item>

    <ion-item *ngIf="isPostbonnApp">
      <ion-label class="text-full-small alignment-large">
        {{ 'PRIVATEPROFILE_DHL_WORKER' | translate }}
      </ion-label>
      <ion-checkbox slot="end" [(ngModel)]="isEmployeeDHL" (ionChange)="employeeCheckboxEvent()">
      </ion-checkbox>
    </ion-item>

  </ion-list>


  <!-- <ion-list>
    <ion-item>
      <ion-label>{{ 'PRIVATEPROFILE_PHONE_TYPE' | translate }}</ion-label>
      <ion-input [(ngModel)]="profile.phoneType" type="text" value=""></ion-input>
    </ion-item>
  </ion-list> -->

  <!-- <ion-list *ngIf="!appDetector.isLeaderBoardApp()">
    <ion-item>
      <ion-label class="font-small alignment-large">{{ 'PRIVATEPROFILE_BORN_DATE' | translate }}</ion-label>
      <ion-datetime [(ngModel)]="birthDay" displayFormat="DD.MM.YYYY" pickerFormat="DD MM YYYY"
        style="position: static; width: 100%; max-width: inherit;" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
        doneText="{{ 'GLOBAL_DONE' | translate }}">
      </ion-datetime>
    </ion-item>
  </ion-list> -->
  <ion-list *ngIf="!appDetector.isLeaderBoardApp()" class="ion-no-padding">
    <ion-item>
      <ion-label class="font-small alignment-large">
        {{ 'PRIVATEPROFILE_BORN_DATE' | translate }}
      </ion-label>
     <ion-datetime-button datetime="datetime"
      style="position: static; width: 100%; max-width: inherit;"
     ></ion-datetime-button>
    </ion-item>

    <ion-modal [keepContentsMounted]="true">
      <ng-template>
        <ion-datetime id="datetime"
        presentation="date"
        [(ngModel)]="birthDay"
        displayFormat="DD.MM.YYYY"
        pickerFormat="DD MM YYYY"
        cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
        doneText="{{ 'GLOBAL_DONE' | translate }}"></ion-datetime>
      </ng-template>
    </ion-modal>
  </ion-list>



  <ion-list *ngIf="!appDetector.isGesunderApp() && !appDetector.isForestApp() && !appDetector.isLeaderBoardApp()" class="ion-no-padding">
    <ion-item>
      <ion-label class="font-small alignment-large">{{ 'PRIVATEPROFILE_PROFILE_TYPE' | translate }}</ion-label>
      <ion-select [(ngModel)]="profile.status" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
        okText="{{ 'GLOBAL_OK' | translate }}" style="position: static; width: 100%;max-width: inherit;">
        <ion-select-option *ngFor="let type of types" value="{{ type.value }}">{{ type.value }}</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>

  <!-- <ion-list *ngIf="!appDetector.isLeaderBoardApp()">
    <ion-list-header text-left>
      {{ 'PRIVATEPROFILE_MY_SPORTARTS_TITLE' | translate }}
    </ion-list-header>
    <ion-item *ngFor="let category of profile.sportTypesVec">
      <mysport-icon [cid]="category.id" small item-start></mysport-icon>
      {{ category.id | categoryName | async | translate }}
    </ion-item>
    <button ion-item (click)="openSportarts()">
      <ion-icon name="add-circle" color="green" small item-start></ion-icon>
      {{ 'PRIVATEPROFILE_EDIT_SPORTARTS' | translate }}
    </button>
  </ion-list> -->


  <ion-list *ngIf="!appDetector.isForestApp()" class="ion-no-padding">
    <ion-list-header text-left>
      {{ 'PRIVATEPROFILE_LOCATION_TITLE' | translate }}
    </ion-list-header>
    <ion-item>
      <ion-label class="alignment font-small alignment-large">{{ 'STREET' | translate }}</ion-label>
      <ion-input [(ngModel)]="profile.homeStreet" type="text"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label class="alignment font-small alignment-large">{{ 'EVENT_HOUSE_NUMBER' | translate }}</ion-label>
      <ion-input [(ngModel)]="profile.homeStreetNo" type="text"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label class="alignment font-small alignment-large">{{ 'PRIVATEPROFILE_ZIP' | translate }}</ion-label>
      <ion-input [(ngModel)]="profile.zip" type="number" maxlength="5" pattern="[0-9]*"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label class="alignment font-small alignment-large">{{ 'PRIVATEPROFILE_CITY' | translate }}</ion-label>
      <ion-input [(ngModel)]="profile.city" type="text"></ion-input>
    </ion-item>
    <ion-item class="search-field-nobg">
      <ion-label class="alignment font-small alignment-large">{{ 'PRIVATEPROFILE_COUNTRY' | translate }}</ion-label>
      <ion-select [(ngModel)]="profile.country" cancelText="{{ 'GLOBAL_CANCEL' | translate }}"
        style="position: static; width: 100%;max-width: inherit;" okText="{{ 'GLOBAL_OK' | translate }}">
        <ion-select-option *ngFor="let country of countries" value="{{ country.value }}">{{ country.text }}</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>
</ion-content>